import type { IconProps } from "./icon-types";

/**
 * X(close/clear). Modal 닫기 / Dropdown 검색어 지우기 등에서 공용.
 */
export const CloseIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
    <path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
